import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import config from "util/ApiforContext";
import RequestHandler from "util/RequestHandler";
import { ColumnHelper } from "util/TableHelper";
import { odata } from "../Filters/Helper";
import Screen from "../../util/Extensions/Screens";
import Iframe from "react-iframe";

import TosOrderSentTableFilter from "../Filters/TosOrderSentTableFilter";

import moment from "moment";

import { Table, Empty, Col, Row, Button,message, Modal, Tooltip, Form, Input, notification, Tag } from "antd";
import {
  BarsOutlined,
  FilePdfOutlined,
  InfoCircleOutlined,
  SendOutlined,
  IdcardOutlined,
  MailOutlined,
  MailFilled,
  DownloadOutlined,
} from "@ant-design/icons";

const baseFilter = "&$filter=DirectiveStatusId ne 1 and DirectiveStatusId ne 7";

const TosSentOrderList = (props) => {
  const isInitialMount = useRef(true);
  const [tableData, setTableData] = useState({
    data: [],
    total: 0,
    loading: true,
  });
  const [selectedRows, setSelectedRows] = useState({
    keys: [],
    data: [],
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState({
    skip: 0,
    take: 15,
    current: 1,
    filter: baseFilter,
  });
  const [isTosAuthorize, setIsTosAuthorize] = useState(false);

  const history = useHistory();

  const [showApprovedUserModal, setShowApprovedUSerModal] = useState(false);

  const [approvedUsers, setApprovedUsers] = useState([]);

   const [isHasDateFilter, setIsHasDateFilter] = useState(false);
    const [isLast7DaysFilterEnabled, setIsLast7DaysFilterEnabled] =
      useState(false);
    const [isLast1DayFilterEnabled, setIsLast1DayFilterEnabled] = useState(false);

  const [isModalVisiblePdf, setIsModalVisiblePdf] = useState(false);
  const [EmailVisible, setEmailVisible] = useState(true);
  const [pdfUrl, setPdfUrl] = useState("");
  const [Email, setEmail] = useState(localStorage.getItem("email") || "");
  const [pdfLoading, setPdfLoading] = useState(false);
  const [directiveNumberForPdf, setDirectiveNumberForPdf] = useState("");

  const getTenantParameter = () => {
    RequestHandler.get("/TenantParameter/GetByTenant").then((response) => {
      if (response) {
        if (
          !response.isHasDateFilter &&
          !response.isLast1DayFilterEnabled &&
          !response.isLast7DaysFilterEnabled
        ) {
          isInitialMount.current = false;
          getTableData();
        }

        setIsHasDateFilter(response.isHasDateFilter);
        setIsLast1DayFilterEnabled(response.isLast1DayFilterEnabled);
        setIsLast7DaysFilterEnabled(response.isLast7DaysFilterEnabled);
      }
    });
  };


  useEffect(() => {
    if (!isInitialMount.current) {
      getTableData();
    }
  }, [tableDataQueryOptions]);

  useEffect(() => {
    RequestHandler.get("/TenantUser/IsTosAuthorize").then((response) => {
       setIsTosAuthorize(response);
       if (!response) {
         RequestHandler.get("/User/MenuPermissions").then((menuResponse) => {
           if (!menuResponse.isAdmin) {
             history.push("/home");
           }
         });
       }
    });

    getTenantParameter();
  }, [])

  useEffect(() => {
      dateFilter();
    }, [isHasDateFilter, isLast1DayFilterEnabled, isLast7DaysFilterEnabled]);


    const dateFilter = () => {
      let startDate;

      if (isLast1DayFilterEnabled) {
        startDate = moment(new Date()).add(-1, "days");
      } else if (isLast7DaysFilterEnabled) {
        startDate = moment(new Date()).add(-7, "days");
      } else if (isHasDateFilter) {
        startDate = moment(new Date()).add(-1, "months");
      }


      if (startDate) {
        const newDateFilter = odata.dateRange(
              "paymentDate",
              startDate,
              new Date()
            );

        setTableDataQueryOptions((prevState) => {
          return {
            ...prevState,
            skip: 0,
            current: 1,
            take: tableDataQueryOptions.take,
            values: {
              paymentDateMin: startDate,
              paymentDateMax: new Date(),
            },
            filter: `${baseFilter} and ${newDateFilter}`,
          };
        });

        isInitialMount.current = false;
      }
    };

  const getTableData = () => {
    const { skip, take, filter } = tableDataQueryOptions;

    setTableData({
      ...tableData,
      loading: true,
    });

     RequestHandler.get(
       `/Directive?$count=true${filter}&$skip=${skip}&$top=${take}`
     ).then((response) => {
          setTableData({
            data: response.value,
            total: response["@odata.count"],
            loading: false,
          });
     });
  };

  const paging = (p) => {
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });
  };
  const onClickCreateOrder = () => {

  };
  const onClickCreatePdf = (id, directiveNumber) => {
    const hideMessage = message.loading("Pdf indiriliyor...", 0);
    setEmailVisible(true);
    RequestHandler.get(
      `/Directive/CreatePdf?id=${id}`
    ).then((response) => {
      hideMessage();
      setPdfUrl(
        config.apiUrl.replace("/api","")+"/content/sourcepdf/tospdf/downloadpdfs/"+response
      );
      setDirectiveNumberForPdf(directiveNumber);
      setIsModalVisiblePdf(true);
    });
  };

  const onChangeEmail = (values) => {
    setEmail(values.target.value);
  };

  const handleCancelPdf = () => {
    setPdfUrl("");
    setIsModalVisiblePdf(false);
  };

  const downloadPdf = () => {
    window.open(pdfUrl, "_blank");
  };

  const sendMail = () => {
    setPdfLoading(true);
    if (Email.length > 0) {
      RequestHandler.post(
        `/Directive/SendMail`,
        { Email: Email, Path: pdfUrl, ScreenOption: Screen.screen },
        false,
        { rawResponse: true }
      ).then((res) => {
        if (res.data === "NotFound") {
          notification.error({
            message: "HATA",
            description: "Mail adresi kayıtlı değil.",
            duration: 2,
          });
          setPdfLoading(false);
        } else if (res.status == 204 || res.status == 200) {
          setPdfLoading(false);
          setIsModalVisiblePdf(false);
          notification.success({
            message: "BAŞARILI",
            description: "Mail gönderme işlemi başarılı.",
            duration: 2,
          });
        }
      });
    } else {
      notification.error({
        message: "HATA",
        description: "Mail adresi girilmedi.",
        duration: 2,
      });
      setPdfLoading(false);
    }
  };
  const onClickRetryDirective = (selectedRows) => {
    RequestHandler.post(
      "/Directive/RetryDirective",
      {
        directiveIds: selectedRows
      },
      true
    ).then((res) => {
      window.location.reload();
    });
    setTimeout(() => {
    }, 500);
  };
  const onClearTableFilter = () => {
    if (
      !isHasDateFilter &&
      !isLast1DayFilterEnabled &&
      !isLast7DaysFilterEnabled
    ) {
      setTableDataQueryOptions({
        skip: 0,
        current: 1,
        take: tableDataQueryOptions.take,
        filter: baseFilter,
        values: undefined,
      });
    } else {
      dateFilter();
    }
  };

  const onFinishTableFilter = (query) => {
    setTableDataQueryOptions((prevState) => {
      return { skip: 0, current: 1, take: prevState.take, filter: query };
    });
  };

  const onTableSelectChange = (selectedKeys, selectedRecords) => {
    setSelectedRows({
      keys: selectedKeys,
      data: selectedRecords,
    });
  };

  const columns = [
    {
      title: "",
      dataIndex: "isSwiftPayment",
      width: 60,
      align: "center",
      render: (data) =>
        data ? (
          <Tooltip title="SWIFT Ödemesi">
            <Tag color="blue" style={{ margin: 0 }}>SWIFT</Tag>
          </Tooltip>
        ) : null,
    },
    {
      title: "Banka",
      dataIndex: "bankLogo",
      width: "8%",
      render: (text) => <img src={text}></img>,
    },
    {
      title: "Talimat Numarası",
      dataIndex: "directiveNumber",
    },
    {
      title: "Ödeme Tarihi",
      dataIndex: "paymentDate",
      render: (data, row, index) => moment(data).format("DD.MM.YYYY"),
    },
    {
      title: "Talimat Durumu",
      dataIndex: "directiveStatus",
    },
    {
      title: "Adet",
      dataIndex: "quantity",
    },
    {
      title: "Tutar",
      dataIndex: "amount",
      render: ColumnHelper.renderDecimal,
      align:"right"
    },
    {
      title: "Para Birimi",
      dataIndex: "currencyCode"
    },
    {
      title: "Açıklama",
      dataIndex: "description",
    },
    {
      title:"Hazırlayan Kişi",
      dataIndex: "creator",
    },
    {
      title: "Onaylayan Kişiler",
      dataIndex: "approvedUsers",
      align: "center",
      render: (data,row) => (
        <a style={{ fontSize: "130%" }}>
          <IdcardOutlined onClick={() => showApprovedUsers(data) } />
        </a>
      )
    },
    {
      title: "Kanal",
      align: "center",
      dataIndex: "isFromApi",
      render: (data) => {
        return data ? "Api" : "Panel"
      }
    },
    {
      title: "Pdf İndir",
      dataIndex: "id",
      align: "center",
      render: (data, row) => (
        <a onClick={() => {onClickCreatePdf(row.id, row.directiveNumber)}} download >
          <FilePdfOutlined style={{ color: "red", fontSize: "130%" }} />
        </a>
      ),
    },
    {
      title: "Detay",
      dataIndex: "id",
      align: "center",
      render: (data, row) => (
        <a style={{ fontSize: "130%" }}>
          <InfoCircleOutlined
            onClick={() => history.push(`tos-sent-payment/${row.id}/false`)}
          />
        </a>
      ),
    },
  ];


  const approvedUserColumns = [
    {
      title: "İsim Soyisim",
      dataIndex: "fullName",
    },
    {
      title: "Onaylama Tarihi",
      dataIndex: "approvedDateTime",
    }
  ];

  const showApprovedUsers = (users) => {
    setApprovedUsers(users);
    setShowApprovedUSerModal(true);
  }

  return (
    <>
      <Row>
        <Col xs={24} md={12} lg={16}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <BarsOutlined /> GÖNDERİLMİŞ TALİMATLAR
          </p>
        </Col>
        <Col xs={24} md={12} lg={8} style={{ textAlign: "right" }}>
        {selectedRows.keys.length > 0 && (
            <Button onClick={() => {onClickRetryDirective(selectedRows.keys)}} style={{ marginBottom: 0 }} disabled={!isTosAuthorize}>
              <SendOutlined /> Talimatı Tekrarla
            </Button>
          )}
          {/* {selectedRows.keys.length > 0 && (
            <Button onClick={onClickCreateOrder} style={{ marginBottom: 0 }}>
              <SendOutlined /> Bankaya Gönder
            </Button>
          )} */}
        </Col>
      </Row>

      <TosOrderSentTableFilter
        onClearFilter={onClearTableFilter}
        onFinishFilter={onFinishTableFilter}
        data={tableDataQueryOptions.values}
        style={{ marginTop: 12, marginBottom: 12 }}
         extraText={
          isHasDateFilter
            ? "Varsayılan olarak son 1 aylık veri listelenmektedir."
            : isLast1DayFilterEnabled
            ? "Varsayılan olarak son 1 günlük veri listelenmektedir."
            : isLast7DaysFilterEnabled
            ? "Varsayılan olarak son 7 günlük veri listelenmektedir."
            : ""
        }
      />

      <Row id="tableArea">
        <Col span={24}>
          <Table
            columns={columns}
            rowSelection={{
              selectedRowKeys: selectedRows.keys,
              onChange: onTableSelectChange,
              getCheckboxProps: (record) => ({
                disabled: !isTosAuthorize
              }),
              renderCell: (checked, record, index, originNode) => {
                const isDisabled = !isTosAuthorize;

                let tooltipMessage = "";
                 if (!isTosAuthorize) {
                  tooltipMessage = "Seçim yetkiniz bulunmuyor.";
                }

                if (isDisabled) {
                  return (
                    <Tooltip title={tooltipMessage}>
                      <span style={{ display: 'inline-block', cursor: 'not-allowed' }}>
                        {originNode}
                      </span>
                    </Tooltip>
                  );
                }

                return originNode;
              }
            }}
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            style={{ overflowX: "auto", maxHeight: "100%", width: "100%" }}
            rowKey="id"
            filterable={true}
            sortable={true}
            pageable={true}
            onChange={paging}
            pagination={{
              defaultPageSize: tableDataQueryOptions.take,
              pageSizeOptions: ["15", "25", "50", "100"],
              showSizeChanger:true,
              total: tableData.total,
              current: tableDataQueryOptions.current,
            }}
            dataSource={tableData.data}
            loading={tableData.loading}
            size="small"
          />
        </Col>
      </Row>

      <Modal visible={showApprovedUserModal} footer={false} onCancel={() => { setShowApprovedUSerModal(false) }} >

        <Table
          columns={approvedUserColumns}
          locale={{
            emptyText: (
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description="Veri Yok"
              />
            ),
          }}
          style={{ overflowX: "auto", maxHeight: "100%", width: "100%" }}
          rowKey="approvedDateTime"
          dataSource={approvedUsers}
          loading={tableData.loading}
          size="small"
        />
      </Modal>

      <Modal
        title={`${directiveNumberForPdf} no'lu Talimat`}
        width={1000}
        style={{ height: 1000 }}
        visible={isModalVisiblePdf}
        onCancel={handleCancelPdf}
        footer={null}
      >
        <Form
          name="directivePdfMail"
          initialValues={{
            remember: true,
          }}
          fields={[{ name: "Email", value: Email }]}
        >
          <Row>
            <Col span={20}></Col>
            <Col span={2}>
              {EmailVisible ? (
                <MailOutlined
                  style={{ fontSize: 20, marginBottom: 20 }}
                  onClick={() => setEmailVisible(!EmailVisible)}
                />
              ) : (
                <MailFilled
                  style={{ fontSize: 20, marginBottom: 20 }}
                  onClick={() => setEmailVisible(!EmailVisible)}
                />
              )}
            </Col>
            <Col span={2}>
              <DownloadOutlined
                style={{ fontSize: 20, marginBottom: 20 }}
                onClick={() => downloadPdf()}
              />
            </Col>
          </Row>
          <Row hidden={EmailVisible}>
            <Col span={18}>
              <Form.Item
                label="Mail Adresi"
                name="Email"
                style={{ width: "100%" }}
              >
                <Input value={Email} onChange={onChangeEmail} />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item>
                <Button
                  type="primary"
                  onClick={() => sendMail()}
                  loading={pdfLoading}
                >
                  Gönder
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
        <Iframe
          url={pdfUrl}
          width="100%"
          height="1000px"
          id="directivePdfPreview"
          className="myClassname"
          display="initial"
          position="relative"
        />
      </Modal>
    </>
  );
};

export default TosSentOrderList;
